var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
export var ONE_MONTH_TERM = '1';
export var SIX_MONTHS_TERM = '6';
export var TWELVE_MONTHS_TERM = '12';
var OneMonthOption = {
    name: 'one-month',
    descriptionKey: 'eos-tv-shop-ii.text.pack-option-one-month',
    titleKey: 'eos-tv-shop-ii.title.pack-option-one-month',
    term: ONE_MONTH_TERM,
    priceDetail: null
};
var SixMonthsOption = {
    name: 'six-months',
    titleKey: 'eos-tv-shop-ii.title.pack-option-six-months',
    term: SIX_MONTHS_TERM,
    priceDetail: null
};
var TwelveMonthsOption = {
    name: 'twelve-months',
    titleKey: 'eos-tv-shop-ii.title.pack-option-twelve-months',
    term: TWELVE_MONTHS_TERM,
    priceDetail: null
};
export var PackOptionsForStreamz = [
    OneMonthOption,
    __assign({}, SixMonthsOption, { discount: -2, descriptionKey: 'eos-tv-shop-ii.text.streamz-option-six-months' }),
    __assign({}, TwelveMonthsOption, { discount: -3, descriptionKey: 'eos-tv-shop-ii.text.streamz-option-twelve-months' })
];
export var PackOptionsForStreamzB2B = [
    OneMonthOption,
    __assign({}, SixMonthsOption, { discount: -1.65, descriptionKey: 'eos-tv-shop-ii.text.streamz-option-six-months' }),
    __assign({}, TwelveMonthsOption, { discount: -2.48, descriptionKey: 'eos-tv-shop-ii.text.streamz-option-twelve-months' })
];
export var PackOptionsForStreamzBasic = [
    OneMonthOption,
    __assign({}, SixMonthsOption, { discount: -1, descriptionKey: 'eos-tv-shop-ii.text.streamz-basic-option-six-months' }),
    __assign({}, TwelveMonthsOption, { discount: -2, descriptionKey: 'eos-tv-shop-ii.text.streamz-basic-option-twelve-months' })
];
export var PackOptionsForStreamzBasicB2B = [
    OneMonthOption,
    __assign({}, SixMonthsOption, { discount: -0.83, descriptionKey: 'eos-tv-shop-ii.text.streamz-basic-option-six-months' }),
    __assign({}, TwelveMonthsOption, { discount: -1.65, descriptionKey: 'eos-tv-shop-ii.text.streamz-basic-option-twelve-months' })
];
